import React from 'react';
import PropTypes from 'prop-types';

import {Card as ChakraCard} from '@spothero/ui';

const cpCardBaseStyles = {
    boxShadow: 'none',
    borderRadius: 'base',
};

const Card = ({...rest}) => {
    return (
        <ChakraCard
            backgroundColor="white"
            borderRadius={4}
            {...cpCardBaseStyles}
            {...rest}
        />
    );
};

Card.propTypes = {
    className: PropTypes.string,
};

export default Card;
